import { ManipulateType } from 'dayjs';

export type TimePeriod = '24h' | '7d' | '30d' | '90d' | 'custom';

export interface TimeRange {
  from: string;
  to: string;
}

export interface PeriodConfig {
  value: TimePeriod;
  label: string;
  duration: {
    value: number;
    unit: ManipulateType;
  };
}

export const DEFAULT_AUDIT_LOG_PERIODS: PeriodConfig[] = [
  { value: '24h', label: '24h', duration: { value: 24, unit: 'hour' } },
  { value: '7d', label: '7d', duration: { value: 7, unit: 'day' } },
  { value: '30d', label: '30d', duration: { value: 30, unit: 'day' } },
  { value: '90d', label: '90d', duration: { value: 90, unit: 'day' } },
];
